/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PrettyLink from '~atoms/pretty-link';
import { TrackingKeys } from '~constants/tracking-api'
import Tooltip from '../components/atoms/tooltip';
import useTranslate from '~hooks/useTranslate/useTranslate';

export function getObjectValue(obj, path) {
  if (!obj) return null;
  if (!path) return obj;

  const properties = path.split('.');
  const objKey = properties.shift();

  if (obj[objKey] === undefined) return null;
  return getObjectValue(obj[objKey], properties.join('.'));
}

export const getKeyValues = (relation, data, market) => {
  const obj = Object.keys(data).reduce((acc, key) => {
    const dataKey = data[key][0];

    if (dataKey.includes('||')) {
      // if it has || operator AND market
      if (dataKey.includes('[market]')) {
        const path = dataKey.replace('[market]', `.${market}`);
        acc[key] =
          getObjectValue(relation, path.split(' || ')[0]) ||
          getObjectValue(relation, path.split(' || ')[1]);
      } else {
        acc[key] =
          getObjectValue(relation, dataKey.split(' || ')[0]) ||
          getObjectValue(relation, dataKey.split(' || ')[1]);
      }
    } else if (dataKey.includes('[market]')) {
      // contains market data
      acc[key] = getObjectValue(relation, dataKey.replace('[market]', `.${market}`));
    } else {
      acc[key] = getObjectValue(relation, dataKey);
    }
    return acc;
  }, {});

  return obj;
};

export const generateLabel = (key, value, fnc, props) => {
  if (fnc) {
    return fnc(value, props);
  }

  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    return value?.reduce((acc, current, index) => {
      const prefix = index === 0 ? ' ' : ', ';
      return acc + prefix + current.name;
    }, '');
  }

  return value;
};

export const getInfoGridColumnValues = (relation, data, market) => {
  let items = {};
  Object.entries(data).map(([key, item]) => {
    items = {
      ...items,
      [key]: getKeyValues(relation, item, market),
    };
  });

  return items;
};

export const formatGameDate = (value) => {
  const arr = value?.split('-');
  return arr?.reduce((acc, current, index) => {
    const prefix = index === 0 ? '' : '.';
    return acc.replace(/^/, current + prefix);
  }, '');
};
export const generateVolatility = (value) => {
  if (value === null) return useTranslate('low', 'Low');
  return value === 0
    ? useTranslate('low', 'Low')
    : value === 1
      ? useTranslate('medium', 'Medium')
      : useTranslate('high', 'High');
};
export const formatDate = (value) => value?.slice(0, 4);
export const generateYesorNo = (value) =>
  value ? useTranslate('yes', 'Yes') : useTranslate('no', 'No');
export const generateRtp = (value) => (value ? `${value}%` : null);
export const latestItems = (items, props, limit = null) => {
  if (items === null) return null;
  const showMore = props?.showMore || false;
  const customValue = props?.customValue || null;
  const showTooltip = props?.tooltip || false;
  const showAll = props?.showAll || false;
  const setShowMore = props?.setShowMore || null;

  const list = [];
  const tooltipList = [];
  const { length } = Object.values(items);
  const hasCustomValue = customValue;

  if (showAll) {
    limit = Object.values(items).length;
  }

  // show initial values
  Object.values(items)
    ?.slice(0, limit || Object.values(items).length)
    ?.map((res) => {
      list.push(res.name);
    });
  // show see more values
  Object.values(items)
    ?.slice(limit)
    ?.map((res) => {
      tooltipList.push(res.name);
    });

  const itemsString = list.toString().replace(/,/gi, ', ');

  return showMore && length > limit ? (
    <>
      {itemsString}
      {` `}
      {showTooltip ? (
        <Tooltip
          content={tooltipList.toString().replace(/,/gi, ', ')}
          direction="bottom"
          minWidth={20}
        >
          {` ${hasCustomValue
            ? useTranslate(customValue.translationKey, customValue.label)
            : ` ${length - limit} ${useTranslate('more', 'more')}`
            }`}
        </Tooltip>
      ) : (
        <button type="button" onClick={() => setShowMore(true)}>
          {hasCustomValue
            ? useTranslate(customValue.translationKey, customValue.label)
            : `${length - limit} ${useTranslate('more', 'more')}`}
        </button>
      )}
    </>
  ) : (
    itemsString
  );
};
export const generateLicenseAndSupportTypes = (value, props, limit) => {
  if (value === null) return null;
  const arr = value?.split(',');
  return arr?.slice(0, limit).reduce((acc, current, index) => {
    if (!current) {
      return '';
    }

    const prefix = index === 0 ? ' ' : ',';
    return acc + prefix + current;
  }, '');
};
export const isLiveCasino = (value, props) => {
  const translations = props?.translations || null;
  if (value === null) return useTranslate('no', 'No');

  return generateYesorNo(
    Object.values(value)?.find((name) => name === 'livecasino'),
    translations
  );
};
export const getCurrencies = (value) => {
  if (value === null) return null;

  return Object.values(value)
    ?.slice(0, 5)
    ?.map((elm) => elm?.iso_code);
};
export const generateLink = (value, props) => {
  if (value === null) return null;

  const template = props?.template || null;
  const type = props?.type;
  const showTracker = props?.showTracker || false;
  const newTab = props?.newTab || false;
  const addRel = props?.addRel || false;
  let link;
  let text;

  if (type === 'email') {
    link = `mailto:${value}`;
    text = value;
  }

  if (type === 'url') {
    link = value;
    text = showTracker ? value.url : value;

    if (showTracker) {
      return (
        <PrettyLink
          operator={value}
          tracker='main'
          pageTemplate={template}
          rel='nofollow sponsored'
          clickedElement="info_box"
          moduleName={TrackingKeys?.INFOGRID}
          modulePosition={props?.modulePosition}
        >
          {text}
        </PrettyLink>
      )
    }
  }

  const attributes = { href: link };

  if (addRel) {
    attributes.rel = 'nofollow sponsored';
  }

  if (newTab) {
    attributes.target = '_blank';
  }

  return React.createElement('a', attributes, text);
};
export const getMaxWin = (value) => (value ? `${value}x innsatsen` : null);
export const getMaxStake = (value) => (value ? `${value} kroner` : null);
export const removeEmojis = (text) => text?.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '');
export const getExperience = (value, props) => {
  if (value === null) return null;

  const text = props?.text || '';

  return (
    <>
      {value.match(/\d+/)}
      <small>{useTranslate('years', text)}</small>
    </>
  );
};
